import {Alert} from '@mui/lab'
import {PageTitle} from '_metronic/layout/core'
import {serverLocalName} from 'GLOBAL/envVariables'
import AsInstall from 'pages/install/component/AsInstall'
import Install from 'pages/install/component/install'
import {useEffect, useLayoutEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Outlet, Route, Routes, useLocation} from 'react-router-dom'
import {positionAction} from 'redux/action'
import {getInstallAllCount, getPosition} from 'utils/apiCalling/api'
import {loadSignalConfig} from 'utils/config/signalConfig'
import InstallAsStatus from './component/InstallAsStatus'
import InstallStatus from './component/InstallStatus'
import InstallHeader from './layout/InstallHeader'

const InstallPage = (props: any) => {
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const dispatch = useDispatch()
  const location = useLocation()
  const [count, setCount] = useState<any>(null)
  const [getPositionAction, setPositionAction] = useState<any>(false)
  const [errPosition, setErrPosition] = useState<any>(false)
  const [errMesseage, setErrMessage] = useState<any>('')
  const getInstallAllCountCall = () => {
    getInstallAllCount(userInfo, {
      success: (res: any) => {
        setCount(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
    })
  }
  useLayoutEffect(() => {
    getInstallAllCountCall()
    /* 설치 판정 기준은 배포 없이 서버 JSON 으로 바뀔 수 있어 페이지 진입 시 받아둔다.
       실패해도 기본값으로 동작하므로 결과를 기다리지 않는다. */
    loadSignalConfig()
  }, [])

  const getLocatePosition = (onSuccess?: () => void, onFail?: (err: string) => void) => {
    getPosition({
      success: async (res: any) => {
        setPositionAction(true)
        dispatch(
          await positionAction('update', {
            latitude: res?.coords?.latitude,
            longitude: res?.coords?.longitude,
          })
        )
        setTimeout(() => setPositionAction(false), 1800)
        onSuccess?.()
      },
      fail: async (err: any) => {
        setErrMessage(err)
        setErrPosition(true)
        setTimeout(() => setErrPosition(false), 1800)
        onFail?.(err)
      },
    })
  }

  const usingLocateSelecter = (serverName: any) => {
    switch (serverName) {
      case 'prod':
      case 'suncheon':
      case 'mokpo':
      case 'gyeryong':
        return true

      default:
        return false
    }
  }

  useEffect(() => {
    if (location.pathname === '/install/connect' || location.pathname === '/install/as') {
      getLocatePosition()
    }
  }, [location])

  return (
    <>
      {errPosition && (
        <Alert
          severity={usingLocateSelecter(serverLocalName) ? 'error' : 'warning'}
          style={{position: 'absolute', width: '100%', top: 0, left: 0, zIndex: 9999, fontSize: 20}}
        >
          {usingLocateSelecter(serverLocalName) ? errMesseage : 'GPS 사용 불가 지역입니다.'}
        </Alert>
      )}
      {getPositionAction && (
        <Alert
          severity='success'
          style={{position: 'absolute', width: '100%', top: 0, left: 0, zIndex: 9999, fontSize: 20}}
        >
          위치정보를 업데이트 하였습니다.
        </Alert>
      )}
      <Routes>
        <>
          <Route
            element={
              <>
                <InstallHeader count={count} getPosition={getLocatePosition} />
                <Outlet />
              </>
            }
          >
            <Route
              path={'connect'}
              element={
                <>
                  <PageTitle>설치</PageTitle>
                  <Install countCall={getInstallAllCountCall} getPosition={getLocatePosition} />
                </>
              }
            />
            <Route
              path={'status'}
              element={
                <>
                  <PageTitle>설치 현황</PageTitle>
                  <InstallStatus countCall={getInstallAllCountCall} />
                </>
              }
            />
            <Route
              path={'as'}
              element={
                <>
                  <PageTitle>{`A/S`}</PageTitle>
                  <AsInstall countCall={getInstallAllCountCall} getPosition={getLocatePosition} />
                </>
              }
            />
            <Route
              path={'as/complete'}
              element={
                <>
                  <PageTitle>{`A/S 완료`}</PageTitle>
                  <InstallAsStatus />
                </>
              }
            />
          </Route>
        </>
      </Routes>
    </>
  )
}
export default InstallPage
